import React, { useState, useEffect } from 'react';
import { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import { useSelector, useDispatch } from 'react-redux';
import axiosInstance from '../../utils/axiosInstanse';
import CustomDatePicker from './CustomDatePicker';
import CustomCheckbox from './CustomCheckbox';
import { clearNotification } from '../../reduser/notificationSlice';
import { setUserPermissions } from '../../reduser/userSlice';
import { showNotification } from '../../utils/notificationUtils';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import host from '../../host';

import './style.css';

registerLocale('ru', ru);

function MyComponent() {
  const navigate = useNavigate();
  const getCurrentTime = () => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  };

  const [timeFrom, setTimeFrom] = useState(getCurrentTime);
  const [initialLoad, setInitialLoad] = useState(true);
  const [timeBy, setTimeBy] = useState(undefined);
  const [description, setDescription] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [unpaidDate, setunpaidDate] = useState('');
  const [unpaidDate2, setunpaidDate2] = useState('');
  const [unpaidDate3, setunpaidDate3] = useState('');
  const [unpaidDate4, setunpaidDate4] = useState('');
  const [reasonType, setReasonType] = useState({
    service: false,
    personal: false,
    service_in_plane: false,
    unpaid_vacation_time: false,
  });
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const username = useSelector((state) => state.user.username);
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notification);

  const handleCheckboxChange = (field) => {
    if (!reasonType.unpaid_vacation_time) {
      setunpaidDate('');
      setunpaidDate2('');
      setunpaidDate3('');
      setunpaidDate4('');
    }
    setReasonType({
      service: false,
      personal: false,
      service_in_plane: false,
      unpaid_vacation_time: false,
      [field]: true,
    });
  };

  useEffect(() => {
    if (initialLoad) {
      try {
        axiosInstance
          .get(`${host}api/profile/`)
          .then((response) => {
            dispatch(setUserPermissions(response.data.permissions || []));
            setInitialLoad(false);
          })
          .catch(() => {
            setInitialLoad(false);
          });
      } catch {
        setInitialLoad(false);
      }
    }
  }, [initialLoad, dispatch]);

  useEffect(() => {
    if (notification.show) {
      const now = Date.now();
      const elapsedTime = now - notification.startTime;
      const remainingTime = 4000 - elapsedTime;

      if (remainingTime > 0) {
        const timer = setTimeout(() => {
          dispatch(clearNotification());
        }, remainingTime);
        return () => clearTimeout(timer);
      } else {
        dispatch(clearNotification());
      }
    }
  }, [notification, dispatch]);

  const formatDate = (date) => {
    if (!date) return '';
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return [day, month, year].join('.');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (sending) return;
    if (validateForm()) {
      const data = {
        date: formatDate(startDate),
        time_from: timeFrom,
        time_until: timeBy,
        official: reasonType['service'],
        personal: reasonType['personal'],
        official_in_plane: reasonType['service_in_plane'],
        unpaid_vacation_time: reasonType['unpaid_vacation_time'],
        description: description,
        unpaid_date1: unpaidDate === '' ? null : formatDate(unpaidDate),
        unpaid_date2: unpaidDate2 === '' ? null : formatDate(unpaidDate2),
        unpaid_date3: unpaidDate3 === '' ? null : formatDate(unpaidDate3),
        unpaid_date4: unpaidDate4 === '' ? null : formatDate(unpaidDate4),
      };
      setSending(true);
      try {
        const response = await axiosInstance.post(`${host}api/timeoff/`, data);
        if (response.status === 201) {
          setSending(false);
          showNotification(dispatch, 'Запись добавлена!', 'success');
          navigate('/note/archive');
        }
      } catch (err) {
        setSending(false);
        if (err.response?.status === 409) {
          showNotification(dispatch, 'Некорректное время', 'error');
        } else if (err.response?.status === 400) {
          showNotification(dispatch, 'Ошибка валидации', 'error');
        } else {
          showNotification(dispatch, 'Ошибка отправки формы', 'error');
        }
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!timeFrom || !/^\d{2}:\d{2}$/.test(timeFrom))
      newErrors.timeFrom = 'Время начала обязательно';
    if (!timeBy || !/^\d{2}:\d{2}$/.test(timeBy))
      newErrors.timeBy = 'Время окончания обязательно';
    if (
      (!description && reasonType.service) ||
      (!description && reasonType.service_in_plane)
    )
      newErrors.description = 'По служебному причина обязательна';
    if (
      !reasonType.service &&
      !reasonType.personal &&
      !reasonType.service_in_plane &&
      !reasonType.unpaid_vacation_time
    ) {
      newErrors.reasonType = 'Выберите тип записки';
    }
    if (reasonType.unpaid_vacation_time && unpaidDate === '') {
      newErrors.unpaidDate =
        'Необходимо выбрать хотя-бы одну дату, за которую вы заработали дополнительные часы';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="do-container">
      <motion.div
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.12 }}
      >
        <div className="do-card">
          <div className="do-card-header">
            <p className="do-subtitle">Заполните форму для создания записки</p>
          </div>

          <div className="do-card-body">
            <div className="do-username">
              <span>👤</span> Табельный номер: {username}
            </div>

            <form onSubmit={handleSubmit}>
              {/* Дата */}
              <div className="do-field">
                <label className="do-label" htmlFor="datePicker">
                  Дата
                </label>
                <CustomDatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              {/* Время */}
              <div className="do-time-row">
                <div className="do-field">
                  <label className="do-label" htmlFor="timeFrom">
                    Время с
                  </label>
                  <input
                    id="timeFrom"
                    type="time"
                    className={`do-input ${errors.timeFrom ? 'do-input--error' : ''}`}
                    value={timeFrom}
                    onChange={(e) => setTimeFrom(e.target.value)}
                  />
                  {errors.timeFrom && (
                    <div className="do-error">
                      <span>⚠</span> {errors.timeFrom}
                    </div>
                  )}
                </div>
                <div className="do-field">
                  <label className="do-label" htmlFor="timeBy">
                    Время по
                  </label>
                  <input
                    id="timeBy"
                    type="time"
                    className={`do-input ${errors.timeBy ? 'do-input--error' : ''}`}
                    value={timeBy}
                    onChange={(e) => setTimeBy(e.target.value)}
                  />
                  {errors.timeBy && (
                    <div className="do-error">
                      <span>⚠</span> {errors.timeBy}
                    </div>
                  )}
                </div>
              </div>

              {/* Тип причины */}
              <div className="do-field">
                <label className="do-label">Тип записки</label>
                <div className="do-checkbox-group">
                  <CustomCheckbox
                    id="reasonService"
                    label="По служебному"
                    checked={reasonType.service}
                    onChange={() => handleCheckboxChange('service')}
                    err={!!errors.reasonType}
                  />
                  <CustomCheckbox
                    id="reasonServiceIn"
                    label="По служебному внутри завода"
                    checked={reasonType.service_in_plane}
                    onChange={() => handleCheckboxChange('service_in_plane')}
                    err={!!errors.reasonType}
                  />
                  <CustomCheckbox
                    id="reasonPersonal"
                    label="По личному"
                    checked={reasonType.personal}
                    onChange={() => handleCheckboxChange('personal')}
                    err={!!errors.reasonType}
                  />
                  <CustomCheckbox
                    id="reasonUnpaid"
                    label="Неоплаченное время отдыха"
                    checked={reasonType.unpaid_vacation_time}
                    onChange={() =>
                      handleCheckboxChange('unpaid_vacation_time')
                    }
                    err={!!errors.reasonType}
                  />
                </div>
                {errors.reasonType && (
                  <div className="do-error--block">
                    <span>⚠</span> {errors.reasonType}
                  </div>
                )}
              </div>

              {/* Неоплаченное время — доп. даты */}
              {reasonType.unpaid_vacation_time && (
                <motion.div
                  initial={{ opacity: 0, y: -12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.25 }}
                >
                  <div className="do-unpaid-hint">
                    Для оформления записки за ранее отработанное время,
                    пожалуйста, укажите дату (до 4-х), за которую вы заработали
                    дополнительные часы.
                  </div>

                  <div className="do-unpaid-grid">
                    <div className="do-unpaid-row">
                      <div className="do-field">
                        <label className="do-label">Дата</label>
                        <CustomDatePicker
                          selected={unpaidDate}
                          onChange={(date) => setunpaidDate(date)}
                        />
                      </div>
                      {unpaidDate && (
                        <div className="do-field">
                          <label className="do-label">Дата</label>
                          <CustomDatePicker
                            selected={unpaidDate2}
                            onChange={(date) => setunpaidDate2(date)}
                          />
                        </div>
                      )}
                    </div>

                    {unpaidDate2 && (
                      <div className="do-unpaid-row">
                        <div className="do-field">
                          <label className="do-label">Дата</label>
                          <CustomDatePicker
                            selected={unpaidDate3}
                            onChange={(date) => setunpaidDate3(date)}
                          />
                        </div>
                        {unpaidDate3 && (
                          <div className="do-field">
                            <label className="do-label">Дата</label>
                            <CustomDatePicker
                              selected={unpaidDate4}
                              onChange={(date) => setunpaidDate4(date)}
                            />
                          </div>
                        )}
                      </div>
                    )}

                    {errors.unpaidDate && (
                      <div className="do-error--block">
                        <span>⚠</span> {errors.unpaidDate}
                      </div>
                    )}
                  </div>
                </motion.div>
              )}

              {/* Причина (textarea) */}
              <div className="do-field" style={{ marginTop: 4 }}>
                <label className="do-label" htmlFor="descriptionTextarea">
                  Причина
                </label>
                <textarea
                  id="descriptionTextarea"
                  className={`do-input do-textarea ${errors.description ? 'do-input--error' : ''}`}
                  rows={3}
                  placeholder="Кратко опишите причину"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {errors.description && (
                  <div className="do-error">
                    <span>⚠</span> {errors.description}
                  </div>
                )}
              </div>

              {/* Submit */}
              <div className="do-submit-wrap">
                <button
                  type="submit"
                  className="do-btn-submit"
                  disabled={sending || initialLoad}
                >
                  {sending ? (
                    <>
                      <span className="do-spinner" />
                      Отправка...
                    </>
                  ) : (
                    'Отправить'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default MyComponent;